import type { IconDefinition } from '../index.tsx';

export const iconEnvelopeDot: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconEnvelopeDot',
  icon: [
    16,
    16,
    [],
    '',
    'M14.1176 1.41174C15.1471 1.41174 16 2.26468 16 3.2941C16 4.35292 15.1471 5.17645 14.1176 5.17645C13.0588 5.17645 12.2353 4.35292 12.2353 3.2941C12.2353 2.26468 13.0588 1.41174 14.1176 1.41174ZM0.470588 5.70586C0.176471 5.47057 0 5.08821 0 4.70586C0 3.94115 0.617647 3.2941 1.41176 3.2941H11.2941C11.2941 4.85292 12.5 6.08821 14.0294 6.11763L8.32353 10.5588C7.85294 10.9117 7.17647 10.9117 6.70588 10.5588L0.470588 5.70586ZM7.52941 11.7647C8 11.7647 8.5 11.6176 8.91177 11.2941L15.0588 6.52939V13.1764C15.0588 13.9706 14.4118 14.5882 13.6471 14.5882H1.41176C0.617647 14.5882 0 13.9706 0 13.1764V6.52939L6.11765 11.2941C6.52941 11.6176 7.02941 11.7647 7.52941 11.7647Z',
  ],
};
